import { HEADPHONE_VOLUME_COMPENSATION } from "./config";

// Shared dB HL -> gain conversion so every audio feature (tones, noise) sounds consistent.
// Base reference raised (was 0.0001) because the old curve kept 5-25 dB gains so far below the
// typical headphone/ambient noise floor that they were indistinguishable from each other;
// clamped to 1 to avoid clipping/distortion at the high end of the range.
export const dbToVolume = (db: number) =>
  db <= 0 ? 0 : Math.min(1, 0.001 * HEADPHONE_VOLUME_COMPENSATION * Math.pow(10, db / 20));
